export const MOBILE_BREAKPOINT = 640;
export const NARROWER_VIEW_BREAKPOINT = 960;